/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SalesInputs */

const vi_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán hàng`)
};

/**

* @param {Nav_SalesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_sales = /** @type {((inputs?: Nav_SalesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SalesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_sales(inputs)
});